// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import { classes } from "utils/classes";

import styles from "./RolesTable.scss";

export const RolesTable = ({
  visible,
  dataTestId = "table-row-unwrapped",
  children,
}) => {
  return (
    <tr
      className={classes({ [styles.hidden]: !visible })}
      data-test-id={dataTestId}
    >
      <td colSpan={4}>
        <table className={styles.table}>
          <tbody>{children}</tbody>
        </table>
      </td>
    </tr>
  );
};

RolesTable.propTypes = {
  visible: PropTypes.bool.isRequired,
  dataTestId: PropTypes.string,
  children: PropTypes.node.isRequired,
};
